import React from "react"

import {AppAntSwitch, AppToggleButton} from "@components"

import { TABLE_TAB_SELECTED } from "Pages/AnalyzersV2/@constants"
import { tableTabSelected } from "Pages/AnalyzersV2/@signals"
import {Box, Checkbox} from "@mui/material";


const TABS = [
	{ label: 'Min', value: TABLE_TAB_SELECTED.MIN },
	{ label: 'Max', value: TABLE_TAB_SELECTED.MAX }
]

export default function AnalyzerTableActions() {

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
		<AppToggleButton
			sx={{ width: 200, height: 35, mb: .6 }}
			tabs={TABS}
			value={tableTabSelected.value}
			onChange={(_, newValue) => {
				tableTabSelected.value = newValue
			}}
		/>
	</Box>
}